import React, { useContext } from 'react';
import { LabelInternationalizationType } from '../Model';
import { InternationalizationContext } from '../../../../../src/Utils/Contexts';
import { LabelInternationalization } from '../../../../Utils/constants';

export const detectMediaType = (url) => {
	const imageRegex = /^(data:image)|(jpg|png|svg|jpeg|gif|tiff|tif)$/gi; //NOSONAR
	const videoRegex = /^(data:video)|(mp4|3gp|webm)$/g; //NOSONAR
	const youtubeEmbedRegex = /^(https:\/\/www.youtube.com\/embed)/gi;
	const googleDriveRegex = /^(https:\/\/drive.google.com\/)/gi;
	const vimeoEmbedRegex = /^(https:\/\/player.vimeo.com\/video\/)/gi;
	if (imageRegex.exec(url) || googleDriveRegex.exec(url)) return 'image';
	if (videoRegex.exec(url)) return 'video';
	if (youtubeEmbedRegex.exec(url) || vimeoEmbedRegex.exec(url)) return 'iframe';
	return 'image';
};
export function parseJSON(message) {
	try {
		return JSON.parse(
			message
				.replace(/<p>.*?<\/p>/, '')
				.replace(/<i .*>.*<\\?\/i>/g, '') //NOSONAR
				.replace(/<br.?\/?>/g, '')
		);
	} catch (e) {
		try {
			return JSON.parse(
				message
					.replace(/<p>.*?<\/p>/, '')
					//.replace(/<span.*class='apiresponsesplitter'>.*<\\?\/i>/,"")
					.replace(/<span.*class='apiresponsesplitter'>.*/, '')
			);
		} catch (e) {
			console.log('SFJSONParser -> parser error');
			return 'Incorrect answer format';
		}
	}
}
export function responseToCardJSON(listItems) {
	//COMPLETE THE BELOW
	let res = [];
	listItems.map((e, i) => {
		res.push({
			header: { mainText: e.title, subText: e.description },
			body: { type: e.resourceType, url: e.resourceURL },
			footer: {
				mainText: e.subtitle,
				subText: '',
				action: {
					text: e.linkButtonTitle,
					url: e.linkButtonURL,
				},
			},
			extraInfo: { actionText: e.actionText },
		});
	});

	return res;
}

export function decodeHTMLTags(text) {
	return text
		.replace(/ class=\\?"Workflow-link\\?"/g, '')
		.replace(/ class=\\?"Workflow-link\\?"/g, '')
		.replace(/ class=\\?"wf-summary-confirm\\?"/g, '')
		.replace(/&nbsp;/g, ' ')
		.replace(/&lt;/g, '<')
		.replace(/&gt;/g, '>')
		.replace(/<a/g, `<a target='_blank'`);
}

export const anchorTagColorChanger = (html) => {
	const fakeDiv = document.createElement('div');
	fakeDiv.innerHTML = html;

	const allAnchorTag = fakeDiv.getElementsByTagName('a') as any;
	for (let i = 0; i < allAnchorTag.length; i += 1)
		allAnchorTag[i].removeAttribute('style');

	return fakeDiv.innerHTML;
};
export function anchorTagClickHandler(data, cb) {
	const autoSubmitRegex = /javascript:autosubmit\('(.*)'\)/;
	const matches = autoSubmitRegex.exec(data);
	if (matches) {
		const valueOfAutosubmit = matches[1];
		cb(valueOfAutosubmit);
	}
}
export function hexCodeToRGBA(hexcode: string) {
	let color = hexcode.slice(1);
	const rgba = [
		parseInt(color.slice(0, 2), 16),
		parseInt(color.slice(2, 4), 16),
		parseInt(color.slice(4, 6), 16),
		1,
	];
	const alphaHEX = color.slice(6, 8);
	if (alphaHEX.length > 0) {
		const alphaDEC = parseInt(alphaHEX, 16);
		/**
		 * Scale down from 0-255 to 0-1
		 */
		const scaledDownValue = Number(((alphaDEC * 1) / 255).toFixed(2));
		rgba[3] = scaledDownValue;
	}
	return rgba;
}
export const getFileSize = (size: number): string => {
	if (size > 1024 * 1024) {
		return `${(size / 1024 / 1024).toFixed(1)} MB`;
	} else if (size > 1024) {
		return `${(size / 1024).toFixed(1)} KB`;
	} else {
		return `${size.toFixed(1)} B`;
	}
};

export const withSuspense = (C: JSX.Element) => {
	return <React.Suspense fallback=''>{C}</React.Suspense>;
};

export const T = (props: {
	labelName: keyof LabelInternationalizationType;
	langCode?: string;
}): JSX.Element => {
	const contextData = React.useContext(InternationalizationContext);
	const label = contextData.data[props.labelName];
	/**
	 * Fallback to english, as of now
	 */

	return (
		<>
			<div
				dangerouslySetInnerHTML={{
					__html: props.langCode
						? label[props.langCode]
						: label[contextData.currentLanguage] || label.en,
				}}
			></div>
		</>
	);
};

export function TString(props: {
	labelName: keyof LabelInternationalizationType;
	langCode?: string;
	fromClass?: boolean;
}) {
	if (!props.fromClass) {
		const contextData = useContext(InternationalizationContext);
		const label = contextData.data[props.labelName];
		/**
		 * Fallback to english, as of now
		 */

		return props.langCode
			? label[props.langCode]
			: label[contextData.currentLanguage] || label.en;
	} else {
		const contextData = LabelInternationalization;
		const label = contextData[props.labelName];
		/**
		 * Fallback to english, as of now
		 */

		return props.langCode ? label[props.langCode] : label.en;
	}
}

export function getLabelTranslation(data, langCode: string, labelName: string) {
	if (langCode === 'en') {
		return data[labelName];
	} else {
		if (data.multiLingual && data.multiLingual[labelName]) {
			for (let i = 0; i < data.multiLingual[labelName].length; i += 1) {
				if (data.multiLingual[labelName][i].languageCode === langCode) {
					return data.multiLingual[labelName][i].translatedValue;
				}
			}
			return data[labelName];
		} else {
			return data[labelName];
		}
	}
}

// regex for future uses

// /<a (?:.*?)(?!\/a)*>(?:.*?)<\/a>/ selects all anchor statements
// /<(?!br)([^>]+)>/ selects all html tags except anchor and br
